import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { addRequestNote, NewRequestNote } from 'RestAPIs/roster/notes';

const useAddRequestNote = (requestId: number) => {
  const queryClient = useQueryClient();

  return useMutation((newNote: NewRequestNote) => addRequestNote(newNote), {
    onSuccess: () => {
      queryClient.invalidateQueries(['requestNotes', 'list', requestId]);
      showSuccessSnackbar();
    },
    onError: () => {
      showErrorSnackbar();
    }
  });
};

export default useAddRequestNote;
